// extracted by mini-css-extract-plugin
export default {"brandPromo":"eG-z","carousel":"fG-z"};